import React from "react";
import {
    CardContent,
    Stack,
    Typography,
    Grid,
    List,
    ListItem,
    ListItemText, Chip, Avatar,
} from "@mui/material";
import {useSelector} from "react-redux";
import {DetailView} from "../../../../../Components";
import {relativeTimeFormatter} from "../../../../../Setup/Config/formats";


export const Sidebar = () => {

    const user = useSelector((store) => store.users.selected);

    return (
        <DetailView>
            <CardContent>
                <Grid container spacing={0}>
                    <Grid className={"upper-section"} item xs={12}>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Stack spacing={1} justifyContent={"center"} alignItems={"center"}>
                                    <Avatar src={user?.avatar_url || '/images/user-icon-3.jpg'} alt={user?.first_name} sx={{ width: 156, height: 156 }} variant="rounded" />
                                    <Typography variant={"h2"} align={"center"}>{user.first_name} {user.last_name}</Typography>
                                    <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent="center" useFlexGap>
                                        {(user.roles?.length > 0 ? user.roles : []).map((role) => (
                                            <Chip key={role.id} label={role.role_name} size="small" />
                                        ))}
                                    </Stack>
                                </Stack>
                            </Grid>
                            
                            <Grid item xs={12}>
                                <List className={"profile-details"}>
                                    <ListItem>
                                        <ListItemText primary="Email" secondary={user.email || "N/A"} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Language" secondary={user.language || "English"} />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText
                                            primary="Last Login"
                                            secondary={relativeTimeFormatter(user.last_login_at).display}
                                        />
                                    </ListItem>
                                </List>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </DetailView>
    );
};
